import { createGridLayout, createGridItem } from "../../../../store/global/gridlayout";
import { getIntegerRange } from "../../../../utility";

export const contactGridRouteMap = {
  'overview': getIntegerRange(0, 0)
};

export const contactDetailsGrid = createGridLayout({
  layout: [
    createGridItem({
      x: 0,
      y: 0,
      w: 30,
      h: 11.5,
      i: 'group_info',
    }),
    createGridItem({
      x: 0,
      y: 11.5,
      w: 60,
      h: 25,
      i: 'related_contacts',
    })
  ]
});